import React, { FC, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedYear, setYears } from '../features/yearSlice';
import { Box, Paper, Typography } from '@mui/material';

interface CycEvent {
    name: string;
    date: string;
    year: number;
    file: string;
}

export const Home: FC = () => {
    const navigate = useNavigate();
    const [events, setEvents] = useState<CycEvent[]>([]);
    const selectedYear = useSelector((state: any) => state.years.selectedYear);
    const dispatch = useDispatch();

    // Load events from backend
    useEffect(() => {
        fetch('/api/events')
            .then((response) => response.json())
            .then((data: CycEvent[]) => {
                setEvents(data);

                const years = [...new Set(data.map((event) => event.year))].sort((a, b) => b - a);

                if (years[0]) dispatch(setSelectedYear(years[0]));
            })
            .catch((error) => {
                console.error('❌ Error fetching events:', error);
            });
    }, [dispatch]);

    useEffect(() => {
        return () => {
            dispatch(setYears([]));
        };
    }, [dispatch]);

    const uniqueYears = useMemo(() => [...new Set(events.map((event) => event.year))].sort((a, b) => b - a), [events]);

    useEffect(() => {
        dispatch(setYears(uniqueYears));
    }, [uniqueYears, dispatch]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '2rem', paddingBottom: '2rem' }}>
            {/* 📅 Events */}
            <Box
                sx={{
                    width: {
                        xs: '85%',
                        md: '65%',
                    },
                    mx: 'auto',
                    mt: 4,
                    display: 'grid',
                    gap: 2,
                }}
            >
                {events
                    .filter((event) => event.year === selectedYear)
                    .map((event) => (
                        <Paper
                            key={event.file}
                            onClick={() => navigate(`/event/${event.file.replace('.json', '')}`)}
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                boxShadow: 2,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    boxShadow: 4,
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            <Typography variant="h6" fontWeight={600}>
                                {event.name}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                {event.date}
                            </Typography>
                        </Paper>
                    ))}
            </Box>
        </div>
    );
};
